import React, { useContext, useEffect, useState } from 'react'
import AppContext from '../context/AppContext';
import { requestData } from '../services/request';
import { Link, useLocation } from 'react-router-dom';
import sizeObject from '../helpers/sizeObject';
import './ProductDetails.css';
import ImageMagnifier from '../components/Magnifier/Magnifier';
import ActionButton from '../components/ActionButton/ActionButton';
import ShoppingCart from '../components/ShoppingCart/ShoppingCart';
// import Carousel from '../components/Carousel/Carousel';

function ProductDetails(props) {
  const {
    selectedProduct,
    setSelectedProduct,
    filtredList,
    // productList,
  } = useContext(AppContext);
  const [product, setProduct] = useState({});
  const [photo, setPhoto] = useState('');
  const [loading, setLoading] = useState(true);
  // const [carouselData, setCarouselData] = useState([]);

  // const getRandomProducts = () => {
  //   const maxNumberOfItems = 5;
  //   const maxIndex = productList.length - 1;
  //   const newArray = [];

  //   for (let i = 0; i < maxIndex; i ++) {
  //     const randomIndex = Math.floor(Math.random() * productList.length)
  //     const randomItem = productList[randomIndex]
  //     if ( i <= maxNumberOfItems - 1 && !newArray.some((e) => e.id === randomItem.id) ) {
  //       newArray.push(
  //         { id: randomItem.ref, name: randomItem.name, image: randomItem.thumbs[0] }
  //       );
  //     }
  //   }
  //   console.log(newArray)
  //   setCarouselData(newArray)
  // }

  const {
    ref,
    cardPrice,
    cashPrice,
    name,
    description,
    size,
    manufacturer,
    thumbs,
    gender,
    tags,
    status,
    promptDelivery,
  } = selectedProduct;

  const location = useLocation();
  const pathname = location.pathname.split('/')[2];

  const getData = async () => {
    const selected = await requestData(`/clothes/${pathname}`);
    setSelectedProduct(selected);
    setPhoto(selected.thumbs[0]);
    setLoading(false);
  };

  useEffect(() => {
    getData();
    // getRandomProducts();
  }, [])

  const handleProductStorage = () => {
    const currentCart = JSON.parse(localStorage.getItem('cart')) || [];
    const alreadyExists = currentCart.some((e) => e.ref === product.ref)
    if (!currentCart) {
      const array = [product];
      localStorage.setItem('cart', JSON.stringify(array));
    } else if (currentCart && alreadyExists) {
      const index = currentCart.findIndex(e => e.ref === product.ref);
      const newArray = currentCart;
      newArray[index].size = product.size;
      localStorage.setItem('cart', JSON.stringify(newArray));
    } else if (currentCart && !alreadyExists) {
      currentCart.push(product);
      localStorage.setItem('cart', JSON.stringify(currentCart));
    }
  };

  const handleClick = ({ target }) => {
    const { name } = target;
    switch (name) {
      case 'photo-gallery':
        setPhoto(target.src);
        break;
      case 'move-right':
        const newId = ref + 1;
        const newProduct = filtredList.filter((product) => product.ref === newId);
        setSelectedProduct(newProduct);
        console.log('movendo para direita');
        break;
      default:
        break;
    }
  };

  const changeSize = ({ target }) => {
    const { name, value } = target;

    const newSize = {
      ...product.size,
    };
    if (value > selectedProduct.size[name]) {
      newSize[sizeObject[name]] = Number(selectedProduct.size[name]);
    } else {
      newSize[sizeObject[name]] = Number(value);
    }

    const newProduct = {
      ...product,
      ref,
      name: selectedProduct.name,
      cashPrice,
      cardPrice,
      thumbs: thumbs[0],
      size: newSize,
    };
    newProduct.cashTotal = Number((Object.values(newProduct.size)
      .reduce((acc, curr) => acc + curr) * cashPrice).toFixed(2));
    newProduct.parcel = Number(((
      Object.values(newProduct.size)
        .reduce((acc, curr) => acc + curr) * cardPrice
    ) / 4).toFixed(2));
    setProduct(newProduct);
  };

  return (
    loading ? null : (
      <main>
        <section className="product-show">
          <div className="product-photos">
            <div className="product-gallery">
              {
                thumbs.map((photo, index) => (
                  <img
                    className="photo-gallery"
                    name="photo-gallery"
                    key={`photo-${photo}`}
                    src={photo}
                    alt={`${ref}-${index}`}
                    onClick={(e) => handleClick(e)}
                  />
                ))
              }
            </div>
            <ImageMagnifier src={photo} width="60%" />
          </div>
          <div className="product-menu">
            <h1 className="product-title">{name}</h1>
            <p className="product-price">{`R$ ${cashPrice.toFixed(2)}`.replace('.', ',')}</p>
            <p className="product-parcel">{`4x R$ ${(cardPrice / 4).toFixed(2)}`.replace('.', ',')}</p>
            <p className="product-size-text">
              Tamanhos disponíveis:
            </p>
            {
              Object.entries(size).filter((e) => e[1] > 0).map((s) => (
                <div key={s[0]} >
                  <label
                    htmlFor={`input-${s[0]}`}
                    className="size-label"
                  >
                    {sizeObject[s[0]]}
                  </label>
                  <input
                    name={`${s[0]}`}
                    type="number"
                    max={s[1]}
                    min={0}
                    id={`input-${s[0]}`}
                    onChange={changeSize}
                    className="form-input"
                    value={product.size ? product.size[sizeObject[s[0]]] : ""}
                  />
                </div>
              ))
            }            
            <ActionButton
              type="button"
              name="btn-add"
              functionOnClick={handleProductStorage}
              disabled={(!product.ref || !status) || (!product.size || Object.values(product.size).every((e) => e === 0))}
              buttonText="Adicionar ao carrinho"
              buttonType="action"
            />
            {
              (!product.size || Object.values(product.size).every((e) => e === 0)) ? (
                <p className="text-instuction">*Informe quantidade para pelo menos um tamanho</p>
              ) : (
                <p className="text-instuction">*Quantidade limitada ao estoque</p>
              )
            }
            {
              !promptDelivery ? (
                <p className="text-instuction" >*Esse produto é vendido sob encomenda, o prazo para entrega é de até 15 dias úteis após confirmação do pagamento</p>
              ) : null
            }
            {
              !status ? (
                <p className="text-instuction" style={{'color': 'red'}}>*Esse produto está com a venda bloquada, contate o administrador</p>
              ) : null
            }
            {
              description.replaceAll('.', './n').split('/n').map((e, index) => (
                <p key={`description-${index}`} className="product-description">{e}</p>
              ))
            }
          </div>
        </section>
        {/* <Carousel products={carouselData} /> */}
        <ShoppingCart />
      </main>
    )
  )
}

export default ProductDetails;
